export function getSelfDriveColours(){
  const DISTINCT = ["#4e79a7","#f28e2b","#e15759","#76b7b2","#59a14f","#edc948","#b07aa1","#ff9da7","#9c755f","#bab0ab"];

  return DISTINCT
}
/**
 * AVIA's two commissioned questions, and only those two.
 *
 * The wave-3 batteries this file used to carry (who must be at the wheel, what
 * self-driving cars would need to demonstrate) plus a shared ai_use copy were
 * removed deliberately: AVIA did not ask them, so they must not appear in the
 * client tab. They are still in the warehouse and can be restored from git if a
 * later wave re-fields them. Nothing else in the app read them — NJI keeps its
 * own ai_use in nji_aggregator.js.
 */
export function getSelfDriveConfig() {
  const groupsById = {


      


    self_drive_comfort: {
      type: "likert",
      label: "Comfort with self-driving vehicles",
      fulltext: "How comfortable or uncomfortable would you feel about personally using a self-driving vehicle for day-to-day travel?",
      keys: [
  "model_self_driving_very_comf_pred_n",
  "model_self_driving_somewhat_comf_pred_n",
  "model_self_driving_neither_pred_n",
  "model_self_driving_somewhat_uncomf_pred_n" ,
  "model_self_driving_very_uncomf_pred_n"    
      ],
      labels: {
  "model_self_driving_very_comf_pred_n":"Very comfortable",
  "model_self_driving_somewhat_comf_pred_n":"Somewhat comfortable",
  "model_self_driving_neither_pred_n":"Neither",
  "model_self_driving_somewhat_uncomf_pred_n":"Somewhat uncomfortable" ,
  "model_self_driving_very_uncomf_pred_n":"Very uncomfortable"    
      },
      schema:"tracking",
      polarity: {
        neg: ["model_self_driving_very_uncomf_pred_n","model_self_driving_somewhat_uncomf_pred_n"],
        neu: ["model_self_driving_neither_pred_n"],
        pos: ["model_self_driving_very_comf_pred_n","model_self_driving_somewhat_comf_pred_n"],
      },
      // Comfort was asked in waves 3 and 4; the change question is wave-4 only.
      waves: [3, 4],
    },

    self_drive_change: {
      type: "likert",
      label: "Change in comfort with self-driving vehicles",
      fulltext: "Compared to two years ago, have you become more comfortable or less comfortable with the idea of riding in a self-driving vehicle?",
      keys: [
   "model_self_driving_change_MM_comf_pred_n",
  "model_self_driving_change_SM_comf_pred_n",
  "model_self_driving_change_same_pred_n",
  "model_self_driving_change_SL_comf_pred_n" ,
  "model_self_driving_change_ML_comf_pred_n" 
      ],
      labels: {
   "model_self_driving_change_MM_comf_pred_n":"Much more comfortable",
  "model_self_driving_change_SM_comf_pred_n":"Somewhat more comfortable",
  "model_self_driving_change_same_pred_n":"About the same",
  "model_self_driving_change_SL_comf_pred_n":"Somewhat less comfortable" ,
  "model_self_driving_change_ML_comf_pred_n":"Much less comfortable"
      },
      schema:"tracking",
      polarity: {
        neg: ["model_self_driving_change_ML_comf_pred_n","model_self_driving_change_SL_comf_pred_n"],
        neu: ["model_self_driving_change_same_pred_n"],
        pos: ["model_self_driving_change_MM_comf_pred_n","model_self_driving_change_SM_comf_pred_n"],
      },
      waves: [4],
    },

  };

  
  return {  groupsById };
}
const DISTINCT = ["#4e79a7","#f28e2b","#e15759","#76b7b2","#59a14f","#edc948","#b07aa1","#ff9da7","#9c755f","#bab0ab"];

export function buildLabelColorMaps(groupsById) {
  const labels = {};
  const colors = {};
  let colorIdx = 0;

  for (const g of Object.values(groupsById)) {
    for (const k of g.keys) {
      labels[k] = g.full_labels?.[k] || g.labels?.[k] || k;

      if (!colors[k]) {
        if (g.colors?.[k]) {
          colors[k] = g.colors[k];               // ✅ keep explicit colors
        } else if (g.type === "likert") {
          colors[k] = baseColorForLikertKey(g, k); // ✅ fallback
        } else {
          colors[k] = DISTINCT[colorIdx % DISTINCT.length];
          colorIdx += 1;
        }
      }
    }
  }

  return { labels, colors };
}


export function aggregateWeighted(rows, keys, { rowKey, weight = "total", predicate = null } = {}) {
  const acc = Object.create(null);
  const zero = Object.fromEntries(keys.map(k => [k, 0]));

  for (const r of rows || []) {
    if (predicate && !predicate(r)) continue;
    const d = r[rowKey];
    if (!d) continue;
    const w = Number(r[weight] ?? 0);
    if (!acc[d]) acc[d] = { w: 0, sums: { ...zero } };
    acc[d].w += w;
    for (const k of keys) acc[d].sums[k] += Number(r[k] ?? 0) * w;
  }

  const out = {};
  for (const [d, { w, sums }] of Object.entries(acc)) {
    const values = {};
    for (const k of keys) values[k] = w > 0 ? (sums[k] / w) * 100 : 0;
    out[d] = { totalWeight: w, values };
  }
  return out;
}

// utils/demoFilters.js (or wherever you keep it)

// Returns a predicate that matches your dataset’s integer-coded fields
export function buildDemoPredicate({
    gender = null,     // 1=Men, 2=Women
    age = null,        // 1=18–34, 2=35–64, 3=65+
    ethnicity = null,  // 1..5
    party = null,      // 1..4
    education = null,  // 1=No degree, 2=Degree
  } = {}) {
    return (r) => {
      // NOTE: r.<field> should be numbers in your data rows
      if (gender != null && Number(r.gender) !== Number(gender)) return false;
      if (age != null && Number(r.age) !== Number(age)) return false;
      if (ethnicity != null && Number(r.ethnicity) !== Number(ethnicity)) return false;
      if (party != null && Number(r.party_reg) !== Number(party)) return false;
      if (education != null && Number(r.education) !== Number(education)) return false;
      return true;
    };
  }
  
  // If you want to show labels elsewhere:
  export const GENDER = [
    { value: null, label: "All" },
    { value: 1,    label: "Men" },
    { value: 2,    label: "Women" },
  ];
  
  export const AGE = [
    { value: null, label: "All" },
    { value: 1,    label: "18–34" },
    { value: 2,    label: "35–64" },
    { value: 3,    label: "65+" },
  ];
  
  export const ETHNICITY = [
    { value: null, label: "All" },
    { value: 1,    label: "White" },
    { value: 2,    label: "Black" },
    { value: 3,    label: "Hispanic" },
    { value: 4,    label: "Asian" },
    { value: 5,    label: "Other" },
  ];
  
  export const PARTY = [
    { value: null, label: "All" },
    { value: 1,    label: "Dem" },
    { value: 2,    label: "Rep" },
    { value: 3,    label: "Ind" },
    { value: 4,    label: "None" },
  ];
  
  export const EDU = [
    { value: null, label: "All" },
    { value: 1,    label: "No degree" },
    { value: 2,    label: "Degree" },
  ];
  

  export function baseColorForLikertKey(group, key) {
    const pol = group?.polarity || {};

    const tag = Object.entries(pol).find(([_, polKey]) => {
      if (Array.isArray(polKey)) return polKey.includes(key);
      return polKey === key;
    })?.[0];

    if (tag === "pos") return "#2E7D32";
    if (tag === "neg") return "#C62828";
    if (tag === "neu") return "#bab0ab"; // optional: distinguish neutral from fallback
    return "#6e6e6e";
  }

// Tab-as-config default export
export default {
  tab: "selfdrive",
  label: "AVIA",
  get metrics() { return getSelfDriveConfig().groupsById; },
};

